// user@gmail.com => user 이렇게 빼오는 함수
// admin 경우 user 정보에 email 전체가 들어가있는 경우가 많음
export const getUserNameFromEmail = (email: string = '') => email.split('@')[0];
